// extracted by mini-css-extract-plugin
module.exports = {"root":"IconReviewStar_root__3yEyv","filled":"IconReviewStar_filled__2muao"};